import React, { useCallback, useEffect, useState } from "react";
import { Button, Form, Image, Spinner } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../store";
import { api_url } from "../api/config/config";
import { VENDOR_ROLES } from "../config/const";
interface VendorDepartmentDataStructure {
    id: string,
    name: string,
    post_code: number,
    pref: string,
    address1: string,
    address2: string,
    phone: string,
    vendor_departments: VendorDepartmentStructure[]
}
interface VendorDepartmentResponseStructure {
    success: boolean;
    data: VendorDepartmentDataStructure;
}

interface VendorDepartmentUserStructure {
    id: string,
    last_name: string,
    first_name: string,
    title: string,
    role: string,
    status: string,
    bids: {
        aggregate: {
            count: number
        }
    },
    contracts: {
        aggregate: {
            count: number
        }
    },
    [key: string]: any;
}
interface VendorDepartmentStructure {
    id: string,
    name: string,
    users: VendorDepartmentUserStructure[],
    [key: string]: any;
}


const Register: React.FC = () => {

    const location = useLocation();
    const { targetRole } = location.state || {};
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [vendorDepartmentInfo, setVendorDepartmentInfo] = useState<VendorDepartmentStructure[]>([]);
    const [vendorId, setVendorId] = useState<number>();
    const [vendorDepartmentId, setVendorDepartmentId] = useState<string>();
    const [lastName, setLastName] = useState<string>('');
    const [firstName, setFirstName] = useState<string>('');
    const [lastNameKana, setLastNameKana] = useState<string>('');
    const [firstNameKana, setFirstNameKana] = useState<string>('');
    const [title, setTitle] = useState<string>('');
    const [role, setRole] = useState<string>(VENDOR_ROLES.find(roleItem => roleItem.role == targetRole)?.id || '');
    const [phone, setPhone] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    const { userInfo, userToken, error: userError } = useSelector((state: RootState) => state.auth);
    const { vendorInfo, loading: vendorLoading, error: vendorError } = useSelector((state: RootState) => state.vendor);
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const ConvertSelectedDepartmentToId = (select: string) => {
        const selectedDepartment = vendorDepartmentInfo.find((department => department.name === select));
        if (selectedDepartment) setVendorDepartmentId(selectedDepartment.id);
    }

    const handleConfirm = () => {
        if (!validateCreateVendorUser()) return;
        setIsConfirmed(true);

    }

    const fetchVendorUserById = async (user_id: string | number) => {
        const response = await fetch(`${api_url}/getVendorUserById`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: user_id }),
        });

        const res: any = await response.json();
        return res.data;
    }

    const fetchVendorById = async (vendor_id: string) => {
        const response = await fetch(`${api_url}/getVendorById`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ vendor_id: vendor_id }),
        });

        const res: VendorDepartmentResponseStructure = await response.json();
        return res.data;
    }


    const fetchVendorInfo = useCallback(async () => {
        try {
            if (userInfo) {
                const user = await fetchVendorUserById(userInfo.id);
                const vendor = await fetchVendorById(user.vendor_id);
                setVendorDepartmentInfo(vendor.vendor_departments);
                setVendorDepartmentId(vendor.vendor_departments[0]?.id);
                setVendorId(user.vendor_id);
            }

        } catch (error) {
            console.error('Error:', error);
        }
    }, [])

    const validateCreateVendorUser = () => {
        if (!(lastName && firstName && lastNameKana && firstNameKana && email && vendorDepartmentId && role && password && confirmPassword)) {
            alert('必須項目を全て入力してください');
            return false;
        }

        if (password !== confirmPassword) {
            alert('パスワードが一致しません。');
            return false;
        }

        if (password && password.length < 8) {
            alert('パスワードは8文字以上で入力してください。');
            return false;
        }

        return true;
    }


    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            const response = await fetch(`${api_url}/createVendorUser`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    last_name: lastName,
                    last_name_kana: lastNameKana,
                    first_name: firstName,
                    first_name_kana: firstNameKana,
                    email: email,
                    vendor_id: vendorId,
                    vendor_department_id: vendorDepartmentId,
                    title: title,
                    role: role,
                    phone: phone,
                    password: password,
                    confirm_password: confirmPassword
                }),
            });

            if (response.status == 200) {
                navigate('/account_add_completed');
            } else {
                const res: any = await response.json();
                throw new Error(res.message || 'ユーザの作成に失敗しました。');
            }

        } catch (error: any) {
            alert(error.message);
            console.error('Error:', error);
        } finally {
            setIsSubmitting(false);
        }
    }

    useEffect(() => {
        fetchVendorInfo();
    }, [fetchVendorInfo])

    return (
        <>

            <section className="main-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-10 mx-auto">
                            <div className="login-wrapper py-lg-5 py-3 text-center">
                                <Form className="form-theme" method="post">
                                    <Form.Control type="hidden" name="role" />
                                    <Image className="height-90 mb-2" src="assets/images/other/icon-user-bg-white-circle-blue.svg" />
                                    <div className="text-md mb-sm-4 mb-3 fw-400">担当者登録</div>
                                    <div className="border-bottom-5-blue-04"></div>
                                    <div className="bg-ass-demo p-lg-5 p-3 mb-lg-5 mb-sm-4 mb-3">
                                        <div className="col-lg-8 col-11 px-0 mx-auto">
                                            <Form.Group className="text-left mb-4">
                                                <label htmlFor="name1">氏名<img className="img img-fluid required-icon" src="assets/images/registration/required-icon.svg"></img></label>
                                                {
                                                    isConfirmed ?
                                                        <>
                                                            <hr className="mt-0 mb-2" />
                                                            <div className="text-theme fw-400">{lastName} {firstName}</div>
                                                            <div className="text-theme fw-400">{lastNameKana} {firstNameKana}</div>
                                                        </>
                                                        : <div className="row mx-0">
                                                            <div className="col-md-6 pl-0 pr-0 pr-md-1 mb-2"><Form.Control onChange={(e) => setLastName(e.target.value)} value={lastName} type="text" className="rounded-0" required id="last_name" name="last_name" placeholder="姓" /></div>
                                                            <div className="col-md-6 pl-0 pr-0 pl-md-1 mb-2"><Form.Control onChange={(e) => setFirstName(e.target.value)} value={firstName} type="text" className="rounded-0" required id="first_name" name="first_name" placeholder="名" /></div>
                                                            <div className="col-md-6 pl-0 pr-0 pr-md-1 mb-2"><Form.Control onChange={(e) => setLastNameKana(e.target.value)} value={lastNameKana} type="text" className="rounded-0" required name="last_name_kana" placeholder="姓カナ" /></div>
                                                            <div className="col-md-6 pl-0 pr-0 pl-md-1 mb-2"><Form.Control onChange={(e) => setFirstNameKana(e.target.value)} value={firstNameKana} type="text" className="rounded-0" required name="first_name_kana" placeholder="名カナ" /></div>
                                                        </div>
                                                }

                                            </Form.Group>
                                            <Form.Group className="form-group text-left mb-4">
                                                <Form.Label htmlFor="name1">メールアドレス<Image className="required-icon" src="assets/images/registration/required-icon.svg" /></Form.Label>
                                                {
                                                    isConfirmed ?
                                                        <>
                                                            <hr className="mt-0 mb-2" />
                                                            <div className="text-theme fw-400">{email}</div>
                                                        </>
                                                        :
                                                        <Form.Control
                                                            onChange={(e) => setEmail(e.target.value)} value={email}
                                                            type="text" className="rounded-0" required id="email" name="email" placeholder="メールアドレスを入力" />
                                                }
                                            </Form.Group>
                                            <Form.Group className="form-group text-left mb-4">
                                                <Form.Label htmlFor="name1">電話番号を入力</Form.Label>

                                                {
                                                    isConfirmed ?
                                                        <>
                                                            <hr className="mt-0 mb-2" />
                                                            <div className="text-theme fw-400">{phone}</div>
                                                        </>
                                                        :
                                                        <Form.Control
                                                            onChange={(e) => setPhone(e.target.value)} value={phone}
                                                            type="text" className="rounded-0" name="phone" placeholder="電話番号を入力" />
                                                }
                                            </Form.Group>

                                            <Form.Group className="form-group text-left mb-4">
                                                <Form.Label htmlFor="name1">部署<Image className="required-icon" src="assets/images/registration/required-icon.svg" /></Form.Label>
                                                {
                                                    isConfirmed ?
                                                        <>
                                                            <hr className="mt-0 mb-2" />
                                                            <div className="text-theme fw-400">
                                                                {vendorDepartmentInfo.find(department => department.id == vendorDepartmentId)?.name}
                                                            </div>
                                                        </>
                                                        :
                                                        vendorInfo?.role == 'vendor_admin' ? (
                                                            <>
                                                                <Form.Select onChange={e => ConvertSelectedDepartmentToId(e.target.value)} className="custom-select theme-form-select rounded-0" id="department" name="vendor_department_id">
                                                                    {vendorDepartmentInfo && vendorDepartmentInfo.map((dept: VendorDepartmentStructure, index: any) => (
                                                                        <option
                                                                            disabled={isConfirmed}
                                                                            value={dept.id}>
                                                                            {dept.name}
                                                                        </option>
                                                                    ))}


                                                                </Form.Select>
                                                                {/* <select className="custom-select theme-form-select rounded-0" id="department" name="vendor_department_id">
                                                        <option></option>
                                                    </select> */}
                                                                {/* <Form.Control type="hidden" name="vendor_department_id" /> */}
                                                            </>
                                                        ) : (
                                                            <Form.Control type="text" className="rounded-0" disabled />
                                                        )
                                                }


                                            </Form.Group>
                                            <Form.Group className="form-group text-left mb-4">
                                                <Form.Label htmlFor="name1">役職</Form.Label>
                                                {
                                                    isConfirmed ?
                                                        <>
                                                            <hr className="mt-0 mb-2" />
                                                            <div className="text-theme fw-400">
                                                                {title}
                                                            </div>
                                                        </> :
                                                        <Form.Control onChange={(e) => setTitle(e.target.value)}
                                                            disabled={isConfirmed} type="text" value={title} className="rounded-0" name="title" placeholder="役職" />
                                                }
                                            </Form.Group>
                                            <Form.Group className="form-group text-left mb-4">
                                                <Form.Label htmlFor="name1">権限</Form.Label>
                                                {
                                                    isConfirmed ?
                                                        <>
                                                            <hr className="mt-0 mb-2" />
                                                            <div className="text-theme fw-400">
                                                                {VENDOR_ROLES.find(roleItem => roleItem.id == role)?.name}
                                                            </div>
                                                        </>
                                                        :
                                                        <Form.Control value={VENDOR_ROLES.find(roleItem => roleItem.id == role)?.name}
                                                            type="text" className="rounded-0" disabled />
                                                }
                                            </Form.Group>
                                            <Form.Group className="form-group text-left mb-4">
                                                {
                                                    !isConfirmed &&
                                                    <>
                                                        <Form.Label htmlFor="name1">パスワード<Image className="required-icon" src="assets/images/registration/required-icon.svg" /></Form.Label>
                                                        <Form.Control
                                                            onChange={(e) => setPassword(e.target.value)} value={password}
                                                            type="password" className="rounded-0" required id="password" name="password" placeholder="パスワードを入力" />
                                                    </>}
                                            </Form.Group>
                                            <Form.Group className="form-group text-left mb-4">
                                                {
                                                    !isConfirmed &&

                                                    <>
                                                        <Form.Label htmlFor="name33">パスワード(確認)<Image className="required-icon" src="assets/images/registration/required-icon.svg" /></Form.Label>

                                                        <Form.Control onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword}
                                                            type="password" className="rounded-0" required id="password_confirm" name="password_confirm" placeholder="もう一度パスワードを入力" />
                                                    </>}
                                            </Form.Group>
                                        </div>
                                    </div>

                                    <div className="py-3 mb-3 text-center">
                                        {!isConfirmed ? (
                                            <>
                                                <Button type="button" onClick={() => { handleConfirm() }} className="btn-theme btn-danger rounded-pill px-5 me-2"><span className="mx-3">次へ</span></Button>
                                                <Link to="/account" type="button" className="btn btn-theme btn-secondary rounded-pill px-4">追加をキャンセル</Link>
                                            </>) : (
                                            <>
                                                <Button type="button" onClick={handleSubmit} className="btn btn-theme btn-danger rounded-pill px-4 mr-2" disabled={isSubmitting}>
                                                    {isSubmitting ? (
                                                        <span className="d-inline-flex align-items-center">
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                                className="me-2 align-middle"
                                                                style={{ verticalAlign: 'middle', marginRight: "8px" }}
                                                            />
                                                            追加中...
                                                        </span>
                                                    ) : (
                                                        "この内容で追加する"
                                                    )}
                                                </Button>
                                                <Link to="#" type="button" onClick={() => { setIsConfirmed(false) }} className="btn btn-theme btn-secondary rounded-pill px-4">入力内容を修正</Link>
                                            </>)
                                        }
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />

        </>
    )
}

export default Register;